import React from 'react'
import { isProd } from '../../../consts'

export function PreviewWebsites({ data, currentLang }) {
  const prefix = isProd() ? 'www' : 'stage'
  const ContentLink = ({ site, lang }) => {
    const path = data.slug[lang].startsWith('/')
      ? data.slug[lang]
      : `/${lang}/content/${data.slug[lang]}/`

    if (currentLang !== lang) return null
    return (
      <a
        key={site}
        rel="noopener noreferrer"
        target="_blank"
        href={`https://${prefix}.${site}${path}?preview=1`}
      >{`${site}/${lang}/`}</a>
    )
  }

  return (
    <div className="preview-web">
      <b>Preview:</b>
      <ContentLink site="vinissimus.com" lang="es" />
      <ContentLink site="vinissimus.com" lang="en" />
      <ContentLink site="vinissimus.fr" lang="fr" />
      <ContentLink site="vinissimus.it" lang="it" />
      <ContentLink site="vinissimus.co.uk" lang="en" />
      <ContentLink site="hispavinus.de" lang="de" />
    </div>
  )
}
